import React from "react";
import { PlusOutlined } from '@ant-design/icons';
import './BaseStyle.css'
import { Button } from 'antd';

const BaseCreate = (props) =>
  <Button className={ "create-button" } type="primary" { ...props } ><PlusOutlined /> { props.text ? props.text : "Create" } </Button>

export default BaseCreate;
